import * as React from 'react';
import { default as ReactSelect } from 'react-select';
import { Label, LabelSize, Error } from '..';
import { Box, Flex } from '../../CommonUI/Layout';
import { ResponsiveProp } from 'grid-styled';
import '../../Assets/styles/select.css';
import { Text, withTranslations } from 'ilenia';
import { TooltipSettings } from '../../Model';
import { StyleSheet, css } from 'aphrodite';

interface SelectProps {
    id: string;
    name?: string;
    label?: any;
    labelSize?: LabelSize;
    localize?: boolean;
    data: any[];
    value?: any;
    description?: string;
    disabled?: boolean;
    showError?: boolean;
    errorText?: string;
    tooltip?: TooltipSettings;
    translations?: any;
    mt?: ResponsiveProp;
    pl?: ResponsiveProp;
    onChangeEvent?: (type: string, value: string) => void;
}

class SelectComponent extends React.Component<SelectProps> {
    constructor(props: SelectProps) {
          super(props);
    }

    public handleChange = (selectedOption: any) => {
        if (this.props.onChangeEvent) {
            this.props.onChangeEvent(this.props.id, selectedOption.value);
        }
    }

    public validationElements = () => {
        if (this.props.showError) {
            return {
                errorBox: (
                <Error
                    text={this.props.errorText}
                />
                ),
                inputClassName: 'trustpilot-select field-base-error',
                errorMode: true
            };
            } else {
            return {
                errorBox: '',
                inputClassName: 'trustpilot-select',
                errorMode: false
            };
        }
    }

    public render() {
        const {errorBox, inputClassName, errorMode} = this.validationElements();
        const { id, label, labelSize, value, disabled, data, localize, description, tooltip, translations, mt, name, pl = 20 }  = this.props;
        let selectLabel;
        const prefix =  name ? name : label;

        if (label) {
            selectLabel = (
                <Label
                    errorMode={errorMode}
                    htmlFor={id + '_label'}
                    label={label}
                    tooltip={tooltip}
                    labelSize={labelSize}
                />
            );
        }

        let selectDescription;
        if (description) {
            selectDescription = <Box mt={0} mb={16} ><Text id={description} /></Box>;
        }

        const isValueWithinOptions = data.find((item) => (value && typeof value === 'object')
            ? item === value.value
            : item === value);

        const renderValue = (typeof value === 'object')
            ? value
            : {
                value,
                label: localize && isValueWithinOptions && translations && translations[`${prefix}-${value}`] ? <Text id={`${prefix}-${value}`} /> : value
            };
        const options = data.map((item) => {
            return (typeof item === 'object')
                ? item
                : {
                    value: item,
                    label: localize && translations && translations[`${prefix}-${item}`] ? <Text id={`${prefix}-${item}`} /> : item
                };
        });

        return (
            <Box pl={pl} pr={20} mt={mt} className={css(styles.box)}>
                <Flex>
                    {selectLabel}
                    {selectDescription}
                    <ReactSelect
                        id={id}
                        name="form-field-name"
                        value={renderValue}
                        isDisabled={disabled}
                        className={inputClassName}
                        onChange={this.handleChange}
                        classNamePrefix={'trustpilot-select'}
                        options={options}
                    />
                    {errorBox}
                </Flex>
            </Box>
        );
    }
}

const styles = StyleSheet.create({
    box: {
        maxWidth: '390px',
    },
});

export const Select: React.FC<SelectProps> = withTranslations(SelectComponent);
